"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const merge_refs_1 = __importDefault(require("../merge-refs"));
const text_input_1 = require("../styles/text-input");
function TextInput({ label, isError = false, isErrorText = false, helpText = "", inputRef, placeholder = "", 
// intercept these from base attributes so we can look at them
// make sure they get passed to underlying elements
className, // will be merged with outermost element className
value, // used to determine label state
...restInputProps }) {
    const localInputRef = (0, react_1.useRef)(null);
    const [focused, setFocused] = (0, react_1.useState)(false);
    const variant = isError ? "error" : "normal";
    const currentValue = value?.toString() || localInputRef.current?.value || "";
    const isOffset = focused || currentValue.length > 0;
    const handleFocus = e => {
        setFocused(true);
        if (restInputProps.onFocus)
            restInputProps.onFocus(e);
    };
    const handleBlur = e => {
        setFocused(false);
        if (restInputProps.onBlur)
            restInputProps.onBlur(e);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: className, children: [(0, jsx_runtime_1.jsxs)("label", { className: (0, classnames_1.default)((0, text_input_1.labelStyles)()), children: [(0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)((0, text_input_1.labelTextStyles)(isOffset)), children: label }), (0, jsx_runtime_1.jsx)("input", { ...restInputProps, ref: (0, merge_refs_1.default)(inputRef, localInputRef), className: (0, classnames_1.default)((0, text_input_1.inputStyles)(), (0, text_input_1.inputColors)(focused, variant)), placeholder: focused ? placeholder : undefined, value: value, "aria-invalid": isError, onFocus: handleFocus, onBlur: handleBlur })] }), helpText && ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)((0, text_input_1.helpTextStyles)(isErrorText)), "data-testid": "help-text", children: helpText }))] }));
}
exports.TextInput = TextInput;
